import React, { useState } from 'react';

import Accordion from 'components/Accordion';
import Checkbox from 'components/DesignSystem/Checkbox';
import Snackbar from 'components/DesignSystem/Snackbar';
import Searcher from 'components/DesignSystem/Searcher';
import useGroupedLocations from 'hooks/Meteorology/Fields/TrackingForecast/DetailedView/useGroupedLocations';

export default function MultiGroup() {
  const { groups, toggleMultiGroup, isGroupSelected } = useGroupedLocations();

  const [search, setSearch] = useState('');
  const pattern = new RegExp(search.split('').join('.*'), 'i');
  const filteredGroups = groups.filter((g) => pattern.test(g.name));

  return (
    <Accordion.Item eventKey="multigroup" id="multilocation-accordion">
      <Accordion.Header>Grupos</Accordion.Header>
      <Accordion.Body>
        <Searcher value={search} onChange={(e) => setSearch(e.target.value)} />
        {filteredGroups.length === 0 && (
          <Snackbar className="mt-2">Nenhum grupo disponível</Snackbar>
        )}
        {filteredGroups.map((g) => (
          <Checkbox
            key={g.id}
            label={g.name}
            checked={isGroupSelected(g.id)}
            onChange={() => toggleMultiGroup(g.id)}
            className="my-2"
          />
        ))}
      </Accordion.Body>
    </Accordion.Item>
  );
}
